import { forwardRef, InputHTMLAttributes } from 'react';
import classNames from 'classnames';

export type TextInputProps = {
  className?: string;
} & InputHTMLAttributes<HTMLInputElement>;
export const Text = forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, ...rest }: TextInputProps, ref) => {
    return (
      <input
        ref={ref}
        type="text"
        {...rest}
        className={classNames(
          'block w-full shadow-sm focus:ring-primary-100 focus:border-primary-500 text-sm border-neutral-200 rounded-xl placeholder:text-neutral-500 placeholder:font-light',
          className
        )}
      />
    );
  }
);
